// Set cookie options
const targetingCookies = false;
const personalCookies = false;
const analyticsCookies = true;

// Set type
const tagManager = false; // if false then it defaults to gtag
const gtagId = "G-58FZ455VMJ";

// Set up data layer and set everything to denied
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

gtag("consent", "default", {
  ad_user_data: "denied",
  ad_personalization: "denied",
  ad_storage: "denied",
  analytics_storage: "denied",
  personalization_storage: "denied",
  wait_for_update: 500,
});

if (tagManager === true) {
  dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
} else {
  gtag("js", new Date());
  gtag("config", gtagId);
}

// Create the cookie popup
function createCookiePopup() {
  var cookieContainerElement = document.querySelector(".cookie-container");

  if (cookieContainerElement) {
    // If the cookie container is already open then do nothing
  } else {
    // Remove the cookie button
    const cookieLink = document.querySelector("#cookieLink");
    if (cookieLink) {
      cookieLink.remove();
    }

    // Create Cookie Container
    let cookieContainer = document.createElement("div");
    cookieContainer.classList.add("cookie-container");

    // Create intro text
    let cookieIntro = document.createElement("p");
    cookieIntro.innerHTML =
      "We use cookies to improve user experience. Choose what cookies you allow us to use below. You can find out more in our <a href='/cookies'>Cookie Policy</a>";

    // Append intro to container
    cookieContainer.appendChild(cookieIntro);

    // Create cookie options holder
    let cookieOptionsHolder = document.createElement("div");
    cookieOptionsHolder.classList.add("cookie-options");

    // Add cookie options
    addCookieOptions(cookieOptionsHolder);

    // Append options holder to container
    cookieContainer.appendChild(cookieOptionsHolder);

    // Create save button
    let saveButton = document.createElement("button");
    saveButton.type = "button";
    saveButton.classList.add("btn", "btn-save");
    saveButton.id = "cookieSaveBtn";
    saveButton.innerHTML = "Save Preferences";

    // Append save button
    cookieContainer.appendChild(saveButton);

    // Create accept all button
    let consentButton = document.createElement("button");

    consentButton.type = "button";
    consentButton.classList.add("btn", "btn-consent");
    consentButton.id = "cookieConsentBtn";
    consentButton.innerHTML = "Accept All";

    // Append accept all button
    cookieContainer.appendChild(consentButton);

    // Append cookie container to the body
    document.body.appendChild(cookieContainer);

    // Handle button clicks
    var consentBtn = document.querySelector("#cookieConsentBtn");

    // If the 'Accept All' button is clicked then load gtag with everything granted
    consentBtn.addEventListener("click", function () {
      // Set all cookies to true
      if (targetingCookies === true) {
        localStorage.setItem("targeting", "true");
      } else {
        localStorage.setItem("targeting", "false");
      }

      if (personalCookies === true) {
        localStorage.setItem("personal", "true");
      } else {
        localStorage.setItem("personal", "false");
      }

      if (analyticsCookies === true) {
        localStorage.setItem("analytics", "true");
      } else {
        localStorage.setItem("analytics", "false");
      }

      // update consent
      updateConsent();

      // Add cookie so we know that something has been accepted
      localStorage.setItem("consentGranted", "true");

      // Close the cookie popup
      closeCookiePopup();

      cookieHeight();
    });

    // If the save button is clicked load gtag script depnding on what's checked
    var saveBtn = document.querySelector("#cookieSaveBtn");

    saveBtn.addEventListener("click", function () {
      let cookieOptions = document.querySelectorAll(".cookie-option input");

      // Loop through each option and add cookie
      cookieOptions.forEach(function (cookieOption) {
        if (cookieOption.checked) {
          localStorage.setItem(cookieOption.value, "true");
        } else {
          localStorage.setItem(cookieOption.value, "false");
        }
      });

      // update consent
      updateConsent();

      // Add cookie so we know that something has been accepted
      localStorage.setItem("consentGranted", "true");

      // Close the cookie popup
      closeCookiePopup();

      cookieHeight();
    });

    cookieHeight();
  }
}

// Add selected options to the cookie popup
function addCookieOptions(cookieOptionsHolder) {
  // Create options array
  let cookieOptions = ["essential"];

  // Add items to array if selected as true
  if (targetingCookies === true) {
    cookieOptions.push("targeting");
  }

  if (personalCookies === true) {
    cookieOptions.push("personal");
  }

  if (analyticsCookies === true) {
    cookieOptions.push("analytics");
  }

  cookieOptions.forEach(function (cookieOption) {
    // Create holder
    let optionHolder = document.createElement("div");
    optionHolder.classList.add("cookie-option");

    // Create Input
    let optionInput = document.createElement("input");

    optionInput.type = "checkbox";
    optionInput.id = cookieOption;
    optionInput.name = cookieOption;
    optionInput.value = cookieOption;

    if (localStorage.getItem(cookieOption) === "false") {
      optionInput.removeAttribute("checked");
    } else {
      optionInput.checked = "true";
    }

    if (cookieOption === "essential") {
      optionInput.disabled = "true";
    }

    // Create label and description
    let optionLabel = document.createElement("label");
    let labelText = "";

    let optionDesc = document.createElement("p");
    let optionDescText = "";

    if (cookieOption === "targeting") {
      labelText = "Advertising";
      optionDescText =
        "We use these to deliver advertising that is more relevant to you.";
    } else if (cookieOption === "essential") {
      labelText = "Essential";
      optionDescText =
        "Required to enable basic website functionality. You may not disable these.";
    } else if (cookieOption === "personal") {
      labelText = "Personalisation";
      optionDescText =
        "Allows us to remember choices you make and provide enhanced, more personal features.";
    } else if (cookieOption === "analytics") {
      labelText = "Analytics";
      optionDescText =
        "Helps us to understand how the website performs, and how you interact with it.";
    }

    optionDesc.innerHTML = optionDescText;

    optionLabel.htmlFor = cookieOption;
    optionLabel.innerHTML = labelText;
    optionLabel.classList.add("h5", "mb-0");

    optionHolder.appendChild(optionInput);
    optionHolder.appendChild(optionLabel);
    optionHolder.appendChild(optionDesc);

    cookieOptionsHolder.appendChild(optionHolder);
  });
}

// Close the cookie popup
function closeCookiePopup() {
  // Remove the cookie popup
  var cookieContainer = document.querySelector(".cookie-container");
  cookieContainer.remove();

  // Create the cookie button
  createCookieButton();
}

// Create the floating cookie icon button
function createCookieButton() {
  let cookieButton = document.createElement("button");

  cookieButton.type = "button";
  cookieButton.classList.add("btn", "btn-cookie");
  cookieButton.id = "cookieLink";
  cookieButton.setAttribute("aria-label", "Cookie Preferences");
  cookieButton.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 38 38" viewBox="0 0 38 38"><path d="M36.5 19c-4.8-.1-8.7-4-8.7-8.8-4.8 0-8.7-3.9-8.8-8.7-1.9-.3-3.8 0-5.5.9L8.8 4.8c-1.7.9-3.1 2.3-4 4l-2.4 4.7c-.9 1.7-1.2 3.7-.9 5.6l.8 5.2c.3 1.9 1.2 3.6 2.6 5l3.8 3.8c1.4 1.4 3.1 2.2 5 2.5l5.3.8c1.9.3 3.8 0 5.5-.9l4.7-2.4c1.7-.9 3.1-2.3 4-4l2.4-4.7c.9-1.6 1.2-3.5.9-5.4zm-23.4 8.1c-1.3 0-2.3-1.1-2.3-2.3s1.1-2.3 2.3-2.3 2.3 1.1 2.3 2.3-1 2.3-2.3 2.3zm2.4-11.6c-1.3 0-2.3-1.1-2.3-2.3s1.1-2.3 2.3-2.3 2.3 1.1 2.3 2.3-1 2.3-2.3 2.3zm11.7 9.3c-1.3 0-2.3-1.1-2.3-2.3s1.1-2.3 2.3-2.3c1.3 0 2.3 1.1 2.3 2.3s-1 2.3-2.3 2.3z"/></svg>';

  document.body.appendChild(cookieButton);

  const cookieLink = document.querySelector("#cookieLink");

  cookieLink.addEventListener("click", function () {
    createCookiePopup();
  });
}

// Check if consent has been given and updates the data layer
function updateConsent() {
  if (localStorage.getItem("targeting") === "true") {
    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("consent", "update", {
      ad_user_data: "granted",
      ad_personalization: "granted",
      ad_storage: "granted",
    });
  } else {
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("consent", "update", {
      ad_user_data: "denied",
      ad_personalization: "denied",
      ad_storage: "denied",
    });
  }

  if (localStorage.getItem("analytics") === "true") {
    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("consent", "update", {
      analytics_storage: "granted",
    });
  } else {
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("consent", "update", {
      analytics_storage: "denied",
    });
  }

  if (localStorage.getItem("personal") === "true") {
    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("consent", "update", {
      personalization_storage: "granted",
    });
  } else {
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("consent", "update", {
      personalization_storage: "denied",
    });
  }
}

// Calculates the amount of space needed to accommodate the cookie popup when open
function cookieHeight() {
  var cookiePopUp = document.querySelector(".cookie-container");

  if (cookiePopUp) {
    var popUpHeight = cookiePopUp.offsetHeight;
    document.documentElement.style.setProperty(
      "--cookie-height",
      popUpHeight + "px"
    );
  } else {
    document.documentElement.style.setProperty("--cookie-height", 0 + "px");
  }
}

// Run cookieHeight() on load and if the screen size changes
window.addEventListener("load", cookieHeight(), false);
//window.addEventListener("resize", cookieHeight(), false);

window.addEventListener("resize", function () {
  cookieHeight();
});

// Once page has loaded check if cookies have been accepted and create the cookie button
document.addEventListener("DOMContentLoaded", function () {
  if (localStorage.getItem("consentGranted") === "true") {
    // If consent has been provided previously then update consent
    updateConsent();

    if (tagManager === true) {
      var gtmScript = document.createElement("script");
      gtmScript.async = true;
      gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + gtagId;
      var firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(gtmScript, firstScript);
    } else {
      var gtagScript = document.createElement("script");
      gtagScript.async = true;
      gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=" + gtagId;
      var firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(gtagScript, firstScript);
    }

    // Create cookie Button so that cookie preferences can be edited
    createCookieButton();
  } else {
    // If consent has not previously been given then create the cookie popup
    createCookiePopup();

    /*
    if (tagManager === true) {
      var gtmScript = document.createElement("script");
      gtmScript.async = true;
      gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + gtagId;
      var firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(gtmScript, firstScript);
    } else {
      var gtagScript = document.createElement("script");
      gtagScript.async = true;
      gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=" + gtagId;
      var firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(gtagScript, firstScript);
    }
    */
  }
});
